import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useOpenDraftMutation } from '../api/useOpenDraftMutation';
import { useSaveDraftMutation } from '../api/useSaveDraftMutation';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { MESSAGES } from '../../../CommonConstants';
import {
  hasAccessToManagedAccountsSelector,
  isOrionClientSelector,
} from '../../../CommonSelectors/CommonAreaSelector';

interface UseOpenAccountParams {
  clientId: string;
}

interface OpenAccountParams {
  isFromWorkflow?: boolean;
}

export const useOpenAccount = ({ clientId }: UseOpenAccountParams) => {
  const { mutateAsync: openDraftAccount, isLoading: isOpeningAccount } = useOpenDraftMutation();

  const { mutateAsync: saveDraftAccount, isLoading: isSavingAccount } = useSaveDraftMutation();

  const hasAccessToManagedAccounts = useSelector(hasAccessToManagedAccountsSelector);
  const isOrionClient = useSelector(isOrionClientSelector);

  const onOpenAccount = useCallback(
    async ({ isFromWorkflow = false }: OpenAccountParams = {}) => {
      try {
        const { data } = await openDraftAccount({
          clientId,
          isFromWorkflow,
        });

        const { id: draftId } = await saveDraftAccount({ clientId, data });

        ADV.util.Router.go2('AccountOpening', { clientId, draftId, isFromWorkflow });
      } catch (err) {
        console.error(err);

        toast.error(MESSAGES.GENERIC_ERROR);
      }
    },
    [clientId, openDraftAccount, saveDraftAccount],
  );

  return {
    isLoading: isOpeningAccount || isSavingAccount,
    canOpenAccount: isOrionClient && hasAccessToManagedAccounts,
    onOpenAccount,
  };
};
